<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/community">In the Community </a></li>
                            <li><a routerLink="/foundation" >Foundation</a></li>
                            <!-- <li><a href="javascript:void(0);" >Leicestershire Cricket Society</a></li>
                            <li><a href="javascript:void(0);">Coaching Camps</a></li>
                            <li><a routerLink="/cricket"class="active"> Mike Turner Indoor Cricket Centre</a></li>                                                                                        -->
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="community-cricket-center-section cf">
        <div class="container">
            <div class="community-cricket-center-top">
                <h3>COMMUNITY & COACHING</h3>
                <h2>Mike Turner Cricket Centre</h2>
                <p>We are lucky to possess a fabulous indoor cricket school, named the Mike Turner Cricket Centre after the man who did tremendous work during his long and dedicated career at Leicestershire CCC.</p>
            </div>
            <div class="community-cricket-centre-center">
                <h3>Videos</h3>
                <div class="community-cricket-video">
                    <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidevideoConfig">
                        <div ngxSlickItem class="community-cricket-video-box slide">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem class="community-cricket-video-box slide">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem class="community-cricket-video-box slide">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem class="community-cricket-video-box slide">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ngxSlickItem class="community-cricket-video-box slide">
                            <img src="assets/images/1607975006_player-sponsorship.jpg" alt="">
                            <div class="community-cricket-video-box-overlay">
                                <div class="community-cricket-video-box-overlay-inner">
                                    <div class="community-cricket-video-overlay-text">
                                        <p>Leaping into Monday like...</p>
                                    </div>
                                    <div class="community-cricket-video-overlay-btn">
                                        <a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png" alt=""></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="community-cricket-centre-bottom">
                <div class="community-cricket-centre-bottom-content">
                    <p>We are lucky to possess a fabulous indoor cricket school, named the Mike Turner Cricket Centre after the man who did tremendous work during his long and dedicated career at Leicestershire CCC.</p>
                    <p>Dips Patel, who is an ECB Level Three Qualified Coach, is the new manager of the Mike Turner Cricket Centre. Dips is well-known in cricket circles throughout Leicestershire and Rutland for his previous coaching work and through his role as captain of Loughborough Town CC.</p>
                    <p>Dips is supported by Les Taylor and Stephen Franklin and other ECB Qualified Coaches. Andy Siddall is an ECB Level Four Qualified Coach and Leicestershire CCC first team players also lend a hand at the coaching clinics.</p>
                    <p>We offer school holiday clinics, group and individual coaching sessions and are also in the process of launching indoor tournaments. </p>
                    <p>The group coaching clinics cater for boys and girls aged between 6 and 18. The individual coaching sessions give you either a half hour or an hour session, which is one-to-one with a coach. This allows you to develop the specific skills of your choice.</p>
                    <p>The cricket centre has three top-of-the-range cricket nets which have been recently resurfaced. They are available to hire during evenings and weekends over the winter. The complex at the Bennett End of the ground also includes a gymnasium, syndicate rooms and lecture theatre as well as the main cricket hall.</p>
                    <p>Changing rooms, showers, viewing gallery, bar and social area are all available to participants in such activities, while there is car parking within extremely close proximity.</p>
                    <p>For further details of these exciting opportunities, please call <a href="tel:+0116 245 2467"> 0116 245 2467</a> or e-mail Elaine Pickering at <a href="mailto:coachingsecretary@leicestershireccc.co.uk">coachingsecretary@leicestershireccc.co.uk</a></p>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->